<template>
  <div>
    <v-data-table
      fixed-header
      :headers="headers"
      :items="siteUnitEvents"
      :items-per-page="20"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, -1]
      }"
      height="600"
      class="siteUnitEvents-table"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      multi-sort
    >
      <template #header.id="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <TwoArrowSort class="siteUnitEvents-table--sort-icon" />
        </div>
      </template>

      <template #header.site="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <TwoArrowSort class="siteUnitEvents-table--sort-icon" />
        </div>
      </template>

      <template #header.date="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <TwoArrowSort class="siteUnitEvents-table--sort-icon" />
        </div>
      </template>

      <template #header.status="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <TwoArrowSort class="siteUnitEvents-table--sort-icon" />
        </div>
      </template>

      <template #item.id="{ item }">
        {{ item.id }}
      </template>

      <template #item.site="{ item }">
        {{ item['SiteUnit.Site.siteName'] }}
      </template>

      <template #item.date="{ item }">
        {{ formatDateHourMinute(item.date) }}
      </template>

      <template #item.status="{ item }">
        {{ formatStatus(item.status) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { formatValues } from '@/mixins/formatValues.mixin';
import TwoArrowSort from '@/components/common/icons/TwoArrowSort';

export default {
  name: 'SiteUnitEventsTable',
  components: {
    TwoArrowSort
  },
  mixins: [formatValues],
  props: {
    siteUnitEvents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sortBy: ['id'],
      sortDesc: [true, true, true, true]
    };
  },
  computed: {
    headers() {
      return [
        {
          text: 'ID',
          divider: true,
          align: 'start',
          sortable: true,
          width: '6%',
          value: 'id'
        },
        {
          text: 'Site',
          divider: true,
          align: 'start',
          width: '20%',
          sortable: true,
          value: 'SiteUnit.Site.siteName'
        },
        {
          text: 'Date',
          divider: true,
          align: 'start',
          width: '14%',
          sortable: true,
          value: 'date'
        },
        {
          text: 'Statut',
          divider: true,
          align: 'start',
          width: '60%',
          sortable: true,
          value: 'status'
        }
      ];
    }
  },
  mounted() {},
  methods: {
    formatStatus(status) {
      if (status === 0) {
        return 'Connexion';
      }
      if (status === 1) {
        return 'Déconnexion';
      }
    }
  }
};
</script>

<style lang="scss">
.siteUnitEvents-table {
  .v-data-table-header__icon {
    display: none;
  }

  .v-input--selection-controls__input {
    .v-icon {
      color: #3dd598 !important;
    }
  }

  &--sort-icon {
    min-width: 24px;
    min-height: 24px;
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }

  td:nth-child(1) {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  tr:last-child {
    td {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
  }

  thead {
    th {
      background-color: white;
      border-top: thin solid rgba(0, 0, 0, 0.12);
    }

    th:nth-child(1) {
      border-left: thin solid rgba(0, 0, 0, 0.12);
    }
  }
}
</style>
